var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-page-wrapper"},[_c('d-routed-tabs',{attrs:{"items":_vm.tabs,"role-id":_vm.currentUser.roleId}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }